import { createAction } from "redux-actions";

export const getUpsellModalByRuleId = createAction(
  "API:UPSELL_GET_UPSELL_MODAL_BY_RULE_ID",
  (storeId, ruleId) => ({
    url: `/api/v1/upsell-modal/stores/${storeId}/rules/${ruleId}`
  })
);
